import React, { useEffect, useState } from "react";
import { API, STATIC } from "../../constants/env";
import swal from "sweetalert";
import moment from "moment";
import Select from "react-select";
import { Controller } from "react-hook-form";
const ExamForm = (props) => {
  const [classes, setClasses] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [period, setPeriod] = useState(false);

  useEffect(() => {
    const fetchClasseData = () => {
      fetch(API.classes.all, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((res) => res.json())
        .then((response) => {
          if (response.error) {
            return swal("Error", response.message, "error");
          }
          response = response.map((classe) => ({
            value: classe._id,
            label: classe.name,
          }));
          setClasses(response);
        })
        .catch((e) => {
          return swal("Error", e.message, "error");
        });
      fetch(API.subjects.all, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((res) => res.json())
        .then((response) => {
          if (response.error) {
            return swal("Error", response.message, "error");
          }
          response = response.map((subject) => ({
            value: subject._id,
            option: `${subject.level}:  ${subject.name}`,
          }));
          setSubjects(response);
        })
        .catch((e) => {
          return swal("Error", e.message, "error");
        });
    };

    fetchClasseData();
  }, []);

  useEffect(() => {
    if (props.data) {
      setPeriod(props.data.period);
    }
  }, [props.data]);
  useEffect(() => {
    if (props.data) {
      if (props.data.classe) {
        props.setValue(
          "classe",
          props.data?.classe
            ? props.data.classe.map((elem) => ({
                value: elem.value,
                label: elem.label,
              }))
            : {}
        );
      }
    }
  }, [props]);

  return (
    <div className="card card-custom">
      {/*begin::Form*/}
      <form onSubmit={props.handleSubmit(props.onSubmit)}>
        <div className="card-body">
          <div className="row">
            <div className="col-4 form-group">
              <label>
                La Matiére <span className="text-danger"> *</span>
              </label>
              <select
                className="form-control"
                ref={props.register}
                name="subject"
                placeholder="Selectionnez une classe"
              >
                {subjects.map(({ option, value }, index) => {
                  if (props.data) {
                    if (value === props.data.subject._id) {
                      return (
                        <option selected value={value} key={index}>
                          {option}
                        </option>
                      );
                    } else {
                      return (
                        <option value={value} key={index}>
                          {option}
                        </option>
                      );
                    }
                  } else {
                    return (
                      <option value={value} key={index}>
                        {option}
                      </option>
                    );
                  }
                })}
              </select>
            </div>
            <div className="col-4 form-group">
              <label>
                La Classe <span className="text-danger"> *</span>
              </label>
              {/* Select-Form with react-hook-form */}
              <Controller
                control={props.control}
                as={
                  <Select
                    className="basic-multi-select"
                    classNamePrefix="select"
                  />
                }
                options={classes}
                name="classe"
                isClearable
                isMulti
              />

              {/*
              <select

                className="form-control"
                ref={props.register}
                name="classe"
                placeholder="Selectionnez une classe"
              >
                {classes.map(({ option, value }, index) => {
                  if (props.data) {
                    if (value === props.data?.classe._id) {
                      return (
                        <option selected value={value} key={index}>
                          {option}
                        </option>
                      );
                    } else {
                      return (
                        <option value={value} key={index}>
                          {option}
                        </option>
                      );
                    }
                  } else {
                    return (
                      <option value={value} key={index}>
                        {option}
                      </option>
                    );
                  }
                })}
              </select>
                  */}
            </div>
            <div className="col-4">
              <label>
                Triméstre <span className="text-danger"> *</span>
              </label>
              <select
                className="form-control"
                ref={props.register}
                name="semester"
                placeholder="Selectionnez une Semester"
              >
                {STATIC.PERIODE("Annuel").map(({ option, value }, index) => {
                  if (props.data) {
                    if (value === props.data?.semester) {
                      return (
                        <option selected value={value} key={index}>
                          {option}
                        </option>
                      );
                    } else {
                      return (
                        <option value={value} key={index}>
                          {option}
                        </option>
                      );
                    }
                  } else {
                    return (
                      <option value={value} key={index}>
                        {option}
                      </option>
                    );
                  }
                })}
              </select>
            </div>
          </div>
          <div className="row">
            <div className="form-group col-2">
              <label>Par period ?</label>
              <input
                onChange={(e) => setPeriod(e.currentTarget.checked)}
                ref={props.register}
                name="period"
                type="checkbox"
                style={{ width: 30, height: 30, marginLeft: 30 }}
                className="form-control"
                defaultChecked={props.data?.period}
              />
            </div>
            <div className="form-group col-5">
              <label>
                {period ? "Start" : "Date"}
                <span className="text-danger"> *</span>
              </label>
              <input
                ref={props.registerRequired}
                name="date"
                type="date"
                className="form-control"
                placeholder="Entrer une date"
                defaultValue={
                  props.data
                    ? moment(
                        period ? props.data.startDate : props.data.date
                      ).format("yyyy-MM-DD")
                    : ""
                }
              />
              {props.errors?.date && (
                <span className="text-danger">
                  {period ? "Start" : "Date"} est requis
                </span>
              )}
            </div>
            {period && (
              <div className="form-group col-5">
                <label>
                  End
                  <span className="text-danger"> *</span>
                </label>
                <input
                  ref={props.registerRequired}
                  name="endDate"
                  type="date"
                  className="form-control"
                  placeholder="Entrer une date"
                  defaultValue={
                    props.data
                      ? moment(props.data.endDate).format("yyyy-MM-DD")
                      : ""
                  }
                />
                {props.errors?.endDate && (
                  <span className="text-danger">End est requis</span>
                )}
              </div>
            )}
            {!period && (
              <React.Fragment>
                <div className="form-group col-2">
                  <label>
                    De
                    <span className="text-danger"> *</span>
                  </label>
                  <input
                    ref={props.registerRequired}
                    name="startHour"
                    type="text"
                    className="form-control"
                    placeholder="hh  :  mm"
                    defaultValue={props.data?.startHour}
                  />
                  {props.errors?.startHour && (
                    <span className="text-danger">Requis</span>
                  )}
                </div>
                <div className="form-group col-2">
                  <label>
                    Jusqu'à
                    <span className="text-danger"> *</span>
                  </label>
                  <input
                    ref={props.registerRequired}
                    name="endHour"
                    type="text"
                    className="form-control"
                    placeholder="hh  :  mm"
                    defaultValue={props.data?.endHour}
                  />
                  {props.errors?.endHour && (
                    <span className="text-danger">Requis</span>
                  )}
                </div>
              </React.Fragment>
            )}
          </div>
        </div>

        <div className="card-footer">
          <button type="submit" className="btn btn-primary mr-2">
            Valider
          </button>
          <button
            type="reset"
            onClick={() => props.reset()}
            className="btn btn-secondary"
          >
            <i className="fa fa-redo"></i>reset
          </button>
        </div>
      </form>
      {/*end::Form*/}
    </div>
  );
};

export default ExamForm;
